import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { ValueTable, ValueTableRow } from '@kerfjs/ui/value-table';
import type { SafeHtml } from 'kerfjs';

import type { AnalysisSummaryT } from '../../../../../../shared/contract/analysis.js';
import { CurrencyAmount } from '../../../../currency-amount.js';

/** Ranked opportunities from the selected pricing check. */
export function OverviewOpportunitiesSection({
  opportunities,
  base,
}: {
  opportunities: AnalysisSummaryT['topOpportunities'];
  base: string;
}): SafeHtml {
  if (opportunities.length === 0) return <></>;
  return (
    <List>
      <ListHeader label="Top Opportunities" />
      <ValueTable label="Top Opportunities">
        {opportunities.map((opportunity) => (
          <ValueTableRow
            label={opportunity.description}
            value={<CurrencyAmount value={opportunity.amount} currency={base} />}
          />
        ))}
      </ValueTable>
    </List>
  );
}
